module.exports = __webpack_public_path__ + "static-portal/img/30-1.8b6ab73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/30-1.jpg
// module id = XWBw
// module chunks = 4